import { createFileRoute, redirect } from "@tanstack/react-router"

/*
 *
 * This page is accessible via CNAME (junior.{domain}.cc) and is used to redirect minors to the Auth0 login page with the appropriate parameters.
 * Do not ask me why management keeps changing this, but fyi this might appear unused within the application but it's not.
 *
 */

export const Route = createFileRoute("/_no-auth/minors")({
  beforeLoad: async ({ context: { authClient }, location }) => {
    await authClient.checkSession()
    const isAuth = await authClient.isAuthenticated()

    // If authenticated, redirect to the home page.
    if (isAuth) {
      redirect({
        to: "/",
        throw: true,
        replace: true
      })
    }

    authClient.loginWithRedirect({
      appState: new URLSearchParams({ ...location.search, pathname: location.pathname }).toString(),
      authorizationParams: {
        is_minor: 1
      }
    })
  }
})
